import * as DockingActions from './docking.actions';

export default DockingActions;
